import { render, staticRenderFns } from "./bimList.vue?vue&type=template&id=625580f5&scoped=true&"
import script from "./bimList.vue?vue&type=script&lang=js&"
export * from "./bimList.vue?vue&type=script&lang=js&"
import style0 from "./bimList.vue?vue&type=style&index=0&id=625580f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625580f5",
  null
  
)

export default component.exports